module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_5010.580b4fde.png";